import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/Icons';

// One MCQ answer, rendered on its own line as "a. option text". The CORRECT answer is made
// deliberately explicit — a navy-tinted box with an accent border, a bold accent letter, and a
// solid "Correct" chip on the right — so it can't be missed at a glance. Shared by the exam editor's
// question list and the question-library picker so both read identically.
export function AnswerRow({ letter, text, correct }: { letter: string; text: string; correct: boolean }) {
  const { t } = useTranslation();
  return (
    <li
      className={
        'flex items-center gap-2 rounded px-2.5 py-1.5 text-[12.5px] ' +
        (correct ? 'border border-accent bg-accent/15 font-medium text-ink' : 'border border-transparent text-ink-2')
      }
    >
      <span className={'font-mono ' + (correct ? 'font-semibold text-accent' : 'text-muted')}>{letter}.</span>
      <span className="min-w-0">{text}</span>
      {correct && (
        <span className="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-accent px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-accent-ink">
          <Icon.check className="h-3 w-3" /> {t('admin.exams.editor.correct')}
        </span>
      )}
    </li>
  );
}
